<template>
  <dashboard-chart-card
    title="Tiempo promedio de estados de usuarios"
    @handleDownloadClick="downloadUserStateTimeChart"
  >
    <template #info>
      <a-popover
        trigger="hover"
        class="popover"
        placement="bottomRight"
        :overlayStyle="{ width: '250px' }"
      >
        <template #title>
          <span class="titlePopover">Tiempo promedio de estados de usuarios</span>
        </template>

        <template #content>
          <div class="content">
            Visualiza y descarga el detalle de conexión de tus usuarios en la plataforma. Se
            muestran estados y eventos de {{ ProductName }}.
          </div>
        </template>
        <InfoCircleOutlined class="info-circle" />
      </a-popover>
    </template>

    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      class="user_selector"
      v-model:value="userId"
      @change="handleChange"
      :options="selectOptions"
    />

    <apexcharts :height="250 - 45" type="bar" :options="chartOptions" :series="series" />
  </dashboard-chart-card>
</template>

<script>
import { computed, ref } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import VueApexCharts from "vue3-apexcharts";

import { fetchUserStateTimeResume } from "../../services";
import { downloadResumeAgentState } from "@/app/dashboard/services/";
import { StateOptions, StateTexts } from "@/app/shared/utils/enums";
import { ProductName } from "@/app/shared/utils/constants";

import DashboardChartCard from "../cards/DashboardChartCard.vue";

export default {
  components: {
    DashboardChartCard,
    apexcharts: VueApexCharts,
    InfoCircleOutlined,
  },
  props: {
    users: {
      required: true,
      type: Object,
    },
    filters: {
      required: true,
      type: Object,
    },
  },
  setup(props, context) {
    const userId = ref("");

    const chartData = ref([]);
    const series = computed(() => [{ name: "", data: chartData.value }]);

    const selectOptions = computed(() => [
      { value: "", label: "Todos los usuarios" },
      ...props.users.map((user) => ({ value: user.id, label: user.fullname })),
    ]);

    const chartOptions = {
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: [
          StateTexts[StateOptions.Connected],
          StateTexts[StateOptions.Refreshment],
          StateTexts[StateOptions.Dinner],
          StateTexts[StateOptions.Occupied],
          StateTexts[StateOptions.Services],
          StateTexts[StateOptions.Training],
          StateTexts[StateOptions.NotAvailable],
        ],
      },
      yaxis: {
        labels: {
          formatter: (val) => `${parseInt(val)} min`,
        },
      },
      tooltip: {
        y: {
          formatter: (val) => val,
        },
      },
      stroke: {
        width: 2,
        curve: "smooth",
      },
      colors: ["#B7EB8F", "#FFE58F", "#FA8C16", "#FFA39E", "#91D5FF", "#edc2da", "#87E8DE"],
      fill: {
        opacity: 0.8,
      },
      plotOptions: {
        bar: {
          // columnWidth: "45%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
    };

    const handleChange = () => {
      fetchData();
    };

    const fetchData = async () => {
      if (!props.filters?.startDate) return;

      const data = await fetchUserStateTimeResume(userId.value, props.filters);

      const sortedData = [
        data?.avg_connect_time,
        data?.avg_snack_time,
        data?.avg_dinner_time,
        data?.avg_busy_time,
        data?.avg_spoken_time,
        data?.avg_training_time,
        data?.avg_not_available_time,
      ];

      chartData.value = sortedData.map((val) => (val ? Number(val.toFixed(2)) : 0));
    };

    context.expose({ fetchData });

    return {
      userId,
      series,
      selectOptions,
      chartOptions,
      handleChange,
      ProductName,
    };
  },
  methods: {
    async downloadUserStateTimeChart() {
      await downloadResumeAgentState(this.userId, this.filters);
    },
  },
};
</script>

<style lang="sass" scoped>
.popover
  margin-right: 20px

.info-circle
  font-size: 14px
  color: #51555A

.content
  font-weight: 300
  color: $gray-8

.titlePopover
  font-size: 16px
  font-weight: 600

:deep(.apexcharts-legend-marker)
  border-radius: 50% !important
</style>
